export default class LogPrintActions {

  static NEW_DATA = 'NEW_DATA';
  static UPDATE_DATA='UPDATE_DATA';
  static SHOW_DATA='SHOW_DATA';
  static VIEW_DATA='VIEW_DATA';
  static DELETE_DATA='DELETE_DATA';
  static ON_SUBMIT='ON_SUBMIT';
  static ERROR_DATA='ERROR_DATA';
  static PROCESS_DATA='PROCESS_DATA';
  static RESET_DATA='RESET_DATA';
  static GET_HELPER_BRANCH='GET_HELPER_BRANCH';
  static SUCCESS_DATA='SUCCESS_DATA';
  static ERROR_SERVER='ERROR_SERVER';
  static RESET_LIST='RESET_LIST';
  static APPROVE='APPROVE';
  static REJECT='REJECT';
  static submit(){
    return {
      type: LogPrintActions.ON_SUBMIT
    };
  }

  static create(data) {
    return {
      type: LogPrintActions.NEW_DATA,
      payload: data
    };
  }

  static update(data) {
    return {
      type: LogPrintActions.UPDATE_DATA,
      payload: data
    };
  }

  static view(data) {
    return {
      type: LogPrintActions.VIEW_DATA,
      payload: data
    };
  }

  static delete(data) {
    return {
      type: LogPrintActions.DELETE_DATA
    };
  }

  static list(data) {
    return {
      type: LogPrintActions.SHOW_DATA,
      payload: data
    };
  }
  static resetList() {
    return {
      type: LogPrintActions.RESET_LIST
    };
  }
  static error(error){
    return {
      type: LogPrintActions.ERROR_DATA,
      payload: error
    };
  }
  static success(){
    return {
      type: LogPrintActions.SUCCESS_DATA,
    };
  }
  static process(){
    return {
      type: LogPrintActions.PROCESS_DATA,
    };
  }
  static reset(){
    return {
      type: LogPrintActions.RESET_DATA,
    };
  }
  static helper(data){
    return {
      type: LogPrintActions.GET_HELPER_BRANCH,
      payload:data
    };
  }
  static errorInternal(error){
    return {
      type: LogPrintActions.ERROR_SERVER,
      payload: error
    };
  }
  static approve() {
    return {
      type: LogPrintActions.APPROVE
    };
  }
  static reject() {
    return {
      type: LogPrintActions.REJECT
    };
  }
}